import PageHero from "@/components/PageHero"
import { useScrollReveal } from "@/hooks/useScrollReveal"
import {Mail, Phone, MapPin, MessageCircleDashed as MessageCircle, Instagram, Send} from 'lucide-react'
import { useState } from "react"

const contactInfo = [
  { icon: Mail, label: "E-mail", value: "contato@englishwork.com.br", href: "mailto:contato@englishwork.com.br" },
  { icon: Phone, label: "Telefone", value: "(11) 99999-9999", href: "tel:+5511999999999" },
  { icon: MessageCircle, label: "WhatsApp", value: "Fale com a Lucy IA", href: "https://wa.me/5511999999999" },
  { icon: Instagram, label: "Instagram", value: "@englishwork", href: "https://instagram.com/englishwork" },
  { icon: MapPin, label: "Localização", value: "São Paulo, SP - Brasil", href: "#" },
]

export default function Contato() {
  const section1 = useScrollReveal()
  const [formData, setFormData] = useState({ nome: "", email: "", telefone: "", mensagem: "" })

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  return (
    <>
      <PageHero
        title="Fale Conosco"
        subtitle="Tem alguma dúvida, sugestão ou quer saber mais sobre a English Work? Entre em contato com a nossa equipe."
      />

      <section className="py-20 bg-white">
        <div
          ref={section1.ref}
          className={`max-w-5xl mx-auto px-5 transition-all duration-700 ${section1.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
        >
          <div className="grid md:grid-cols-2 gap-12">
            {/* Formulário */}
            <div>
              <h2 className="text-2xl font-bold mb-6" style={{ color: "#0E8EA0" }}>
                Envie sua mensagem
              </h2>
              <form className="space-y-5" onSubmit={(e) => e.preventDefault()}>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Nome completo</label>
                  <input
                    type="text"
                    name="nome"
                    value={formData.nome}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#0E8EA0] focus:border-transparent text-sm transition-all"
                    placeholder="Seu nome"
                  />
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">E-mail</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#0E8EA0] focus:border-transparent text-sm transition-all"
                      placeholder="seu@email.com"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Telefone</label>
                    <input
                      type="tel"
                      name="telefone"
                      value={formData.telefone}
                      onChange={handleChange}
                      className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#0E8EA0] focus:border-transparent text-sm transition-all"
                      placeholder="(00) 00000-0000"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Mensagem</label>
                  <textarea
                    name="mensagem"
                    value={formData.mensagem}
                    onChange={handleChange}
                    rows={5}
                    className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#0E8EA0] focus:border-transparent text-sm transition-all resize-none"
                    placeholder="Como podemos ajudar?"
                  />
                </div>
                <button
                  type="submit"
                  className="flex items-center gap-2 px-8 py-3.5 text-white font-bold rounded-full text-sm transition-all duration-300 hover:scale-105 hover:shadow-lg"
                  style={{ backgroundColor: "#B038B2" }}
                >
                  <Send size={16} /> Enviar mensagem
                </button>
              </form>
            </div>

            {/* Informações */}
            <div>
              <h2 className="text-2xl font-bold mb-6" style={{ color: "#0E8EA0" }}>
                Canais de atendimento
              </h2>
              <div className="space-y-4">
                {contactInfo.map((item) => (
                  <a
                    key={item.label}
                    href={item.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-4 p-5 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors group"
                  >
                    <div
                      className="w-12 h-12 rounded-xl flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform"
                      style={{ backgroundColor: "#0E8EA015" }}
                    >
                      <item.icon size={22} style={{ color: "#0E8EA0" }} />
                    </div>
                    <div>
                      <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider">{item.label}</p>
                      <p className="text-sm font-semibold text-gray-800">{item.value}</p>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
